import { FinancialAnalysisTable } from "./FinancialAnalysisTable";
import { UnderWritingSummeryTable } from "./UnderWritingSummeryTable";

export const SalesTables = () => {
  return (
    <>
      <FinancialAnalysisTable />
      <UnderWritingSummeryTable />
    </>
  );
};
